import axios  from "axios";
  
import { setupKeycloakInterceptor } from './keycloakAxiosInterceptor';

const axiosInstance = axios.create({
    baseURL: 'https://inventory.phyto.ma/api/v1',
    timeout: 30000,
  });
  
let isSecurityInitialized = false;

export const setupInterceptors = (keycloak: any)  => {

      if (!keycloak.authenticated)
        return;

      isSecurityInitialized = true;

      // Set up the interceptor
      const authInterceptor = setupKeycloakInterceptor({
        keycloak,
        axiosInstance,
        tokenMinValidity: 30,
        enableLogger: true,
        onAuthError: (error) => {
          console.error('Authentication failed (setupInterceptors):', error);
 //TODO         keycloak.login(); // Redirect to login
        },
      });
  
      // Example of using the interceptor's helper methods
      const userRoles = authInterceptor.getUserRoles();
      const isAdmin = authInterceptor.hasRole('admin');
      const tokenInfo = authInterceptor.getTokenInfo();
    }


/**
 * API GET Request
 * 
 * @param uri API uri
 * @param params API GET request parameters
 * @returns 
 */
async function secureGET (uri: string, params: any) {

  if (!isSecurityInitialized) {
    return Promise.reject(new Error(`Security not initialized`));
  }

  console.log("secureGET: " + uri);

  return await axiosInstance.get(uri, {params: params})
        .then(handleResponse)
        .catch(handleError);
}

/**
 * API POST Request
 * 
 * @param uri API uri
 * @param params API POST request parameters
 * @returns 
 */
async function securePOST (uri: string, callData: any) {

  if (!isSecurityInitialized) {
    return Promise.reject(new Error(`Security not initialized`));
  }

  return await axiosInstance.post(uri, callData)
    .then(handleResponse)
    .catch(handleError);

}

/**
 * API POST Request with form
 * 
 * @param uri API uri
 * @param params API POST request parameters
 * @returns 
 */

async function securePOSTFORM (uri: string, formData: FormData, headers: any) {

  if (!isSecurityInitialized) {
    return Promise.reject(new Error(`Security not initialized`));
  }

  return await axiosInstance.post(uri, formData, {headers: headers})
    .then(handleResponse)
    .catch(handleError);

}

  
/**
 * Handles the response when the AXIOS API call fulfills the Promise
 * 
 * @param response 
 * @returns 
 */
function handleResponse (response: any) {

  // Normal/Success response
  //
  if (response.status === 200)
  {
    return response.data;
  }

  // Clients can use this to give feedback to the user
  //

  if ((response.status === 401) || (response.status === 400)) {
//    logOut();
    return;
  }

  return Promise.reject(new Error(`Le serveur a repondu avec un message d'erreur ${response.status}`));

}


function handleError (error: any) {

  try {
    throw new Error(`${error.message} (${error.error})`);
  } catch (e: any) {
    return Promise.reject(new Error(e.message));
  }

  console.log("handleError: " + error);
}

// Exports
//
export const apiService = {
  secureGET,
  securePOST,
  securePOSTFORM,
  handleResponse,
  axios
}
